import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import CButton from '@/components/CButton'
import './index.scss'
import { userlistapi } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import CInput from '@/components/CForm/CInput'
import {Form, Input, message, Modal, Radio} from "antd";
import {resetpasssword,profileedit,changephonesapi } from "@/servers/goodsManageApi";
import Time from "../../login/components/count";
@CBaseComponent
class GoodsManageList extends Component{
    constructor(props) {
        super(props);
        this.getListData = this.getListData.bind(this);
        this.modalOk = this.modalOk.bind(this);
        this.modalCancel = this.modalCancel.bind(this);
        this.modalOk1 = this.modalOk1.bind(this);
        this.modalCancel1= this.modalCancel1.bind(this);
        this.onChange = this.onChange.bind(this)
        this.enterHandler = this.enterHandler.bind(this)
        this.changepsd = this.changepsd.bind(this)
        this.changephone = this.changephone.bind(this)
        this.changHandler =this.changHandler.bind(this)
        this.changHandler1 =this.changHandler1.bind(this)
    }

    componentWillReceiveProps(nextProps) {
    }


    state = {
        id: "",   /* 用户ID */
        name: "",   /* 登录名 */
        realname: "",   /* 姓名 */
        mobile: "",   /* 手机号码 */
        email:"",       /* 电子邮箱 */
        psd:'',
        sex:'',
        idcard:'',
        bankcard:'',
        bankname:'',
        workunit:'',
        position:'',
        jobtitle:'',
        modal: {
            title: '重置密码',
            visible: false,
        },
        modal1: {
            visible: false,
        },
        psd1:'',
        psd2:'',
        mobiles:'',
        vcode:'',
    };

    // 获取用户列表数据
    getListData(){
        this.setState({
            loading: true
        });
        const params = JSON.parse(localStorage.getItem('userList'))
        userlistapi({id:params.clerkid}).then(res=>{
            this.setState({
                id: res.records[0].datalist[0].id,   /* 用户ID */
                name: res.records[0].datalist[0].name,   /* 登录名 */
                realname: res.records[0].datalist[0].realname,   /* 姓名 */
                mobile: res.records[0].datalist[0].mobile,   /* 手机号码 */
                email:res.records[0].datalist[0].email,       /* 电子邮箱 */
                sex:res.records[0].datalist[0].sex,       /* 电子邮箱 */
                idcard:res.records[0].datalist[0].idcard,       /* 电子邮箱 */
                bankcard:res.records[0].datalist[0].bankcard,       /* 电子邮箱 */
                bankname:res.records[0].datalist[0].bankname,       /* 电子邮箱 */
                workunit:res.records[0].datalist[0].workunit,       /* 电子邮箱 */
                position:res.records[0].datalist[0].position,       /* 电子邮箱 */
                jobtitle:res.records[0].datalist[0].jobtitle,       /* 电子邮箱 */
                psd:'******'
            })
        }).catch(err=>{
            console.log(err,'rttt')
        })
    }

    onChange(value,name){
        if (name === 'realname'){
            this.setState({
                realname:value
            })
        }
        if (name === 'mobile'){
            this.setState({
                mobile:value
            })
        }
        if (name === 'email'){
            this.setState({
                email:value
            })
        }

        if (name === 'name'){
            this.setState({
                name:value
            })
        }

        if (name === 'sex'){
            this.setState({
                sex:value
            })
        }
        if (name === 'idcard'){
            this.setState({
                idcard:value
            })
        }
        if (name === 'bankcard'){
            this.setState({
                bankcard:value
            })
        }
        if (name === 'bankname'){
            this.setState({
                bankname:value
            })
        }
        if (name === 'workunit'){
            this.setState({
                workunit:value
            })
        }
        if (name === 'position'){
            this.setState({
                position:value
            })
        }
        if (name === 'jobtitle'){
            this.setState({
                jobtitle:value
            })
        }
    }

    save(){
        const params = {
            realname:this.state.realname,
            mobile:this.state.mobile,
            email: this.state.email,
            name:this.state.name,
            sex:this.state.sex,
            idcard:this.state.idcard,
            bankcard:this.state.bankcard,
            bankname:this.state.bankname,
            workunit:this.state.workunit,
            position:this.state.position,
            jobtitle:this.state.jobtitle,
        }
        profileedit(params).then(res=>{
            if (res.statecode === 0) {
                message.success('更新成功');
                this.getListData()
            } else {
                message.error('更新失败');
            }
        })
    }

    modalOk(){
        if (this.state.psd1 !== this.state.psd2) {
            message.error('两次输入的密码不一致,请重新输入');
            return false
        }
        const params = {
            newpassword:this.state.psd1,
            id:this.state.id
        }
        resetpasssword(params).then(res=>{
            if (res.statecode === 0) {
                message.success('密码重置成功');
                this.setState({
                    modal: {...this.state.modal, visible: false},
                    id:'',
                    psd1:'',
                    psdw:''
                });
                this.getListData()
            } else {
                message.error('密码重置失败');
            }

        }).catch(err=>{
            this.setState({
                modal: {...this.state.modal, visible: false}
            });
        })
    }
    modalCancel(){
        this.setState({
            modal: {...this.state.modal, visible: false}
        })
    }
    modalOk1(){
        const regx = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        if (!regx.test(this.state.mobiles)) {
            message.error('请输入正确的手机号码');
            return false
        }
        const params = {
            mobile:this.state.mobiles,
            vcode:this.state.vcode
        }
        changephonesapi(params).then(res=>{
            if (res.statecode === 0) {
                message.success('修改手机号成功');
                this.setState({
                    modal1: {...this.state.modal1, visible: false},
                    mobiles:'',
                    vcode:'',
                });
                this.getListData()
            } else {
                message.error('修改手机号失败');
            }
        }).catch(err=>{
            this.setState({
                modal: {...this.state.modal, visible: false}
            });
        })
    }
    modalCancel1(){
        this.setState({
            modal1: {...this.state.modal1, visible: false},
            mobiles:'',
            vcode:''
        })
    }
    enterHandler(e,data){
        let value = e.target.value;
        if (data === 'psd1') {
            this.setState({
                psd1:value
            })
        } else {
            this.setState({
                psd2:value
            })
        }
    }
    changHandler(value){
        this.setState({
            mobiles: value
        })
    }

    changHandler1(value){
        this.setState({
            vcode: value
        })
    }
    changepsd(){
        this.setState({
            modal: {...this.state.modal, visible: true},
        });
    }

    changephone(){
        this.setState({
            modal1: {...this.state.modal1, visible: true},
        });
    }

    componentWillMount(){

    }

    changeHandler(e){
        let value = e.target.value;
        this.setState({
            sex: value
        });
    }

    componentDidMount(){
        this.getListData();
    }
    render(){
        return (
            <div className='user-manage-list'>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>用户ID:</div>
                    <CInput
                        value={this.state.id}
                        disabled={true}
                        onChange={(e)=>{this.onChange(e,'realname')}}
                        style={{width:'200px'}}
                    />
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>姓名:</div>
                    <CInput
                        value={this.state.realname}
                        onChange={(e)=>{this.onChange(e,'realname')}}
                        style={{width:'200px'}}
                    />
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>登录名:</div>
                    <CInput
                        value={this.state.name}
                        onChange={(e)=>{this.onChange(e,'name')}}
                        style={{width:'200px'}}
                    />
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>手机号:</div>
                    <CInput
                        value={this.state.mobile}
                        onChange={(e)=>{this.onChange(e,'mobile')}}
                        style={{width:'200px'}}
                    />
                    <CButton type='primary' authId='goodsManageListEdit' onClick={() => this.changephone()} style={{marginLeft:'20px'}}>更换手机号</CButton>
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>密码:</div>
                    <CInput
                        value={this.state.psd}
                        onChange={(e)=>{this.onChange(e,'psd')}}
                        style={{width:'200px'}}
                    />
                    <CButton type='primary' authId='goodsManageListEdit' onClick={() => this.changepsd()} style={{marginLeft:'20px'}}>更改密码</CButton>
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>Email:</div>
                    <CInput
                        value={this.state.email}
                        onChange={(e)=>{this.onChange(e,'email')}}
                        style={{width:'200px'}}
                    />
                </div>


                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>性别:</div>
                    <Radio.Group onChange={(e) => this.changeHandler(e)} value={this.state.sex}>
                        <Radio value='男'>男</Radio>
                        <Radio value='女'>女</Radio>
                    </Radio.Group>
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>身份证号码:</div>
                    <CInput
                        value={this.state.bankcard}
                        onChange={(e)=>{this.onChange(e,'bankcard')}}
                        style={{width:'200px'}}
                    />
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>银行卡号:</div>
                    <CInput
                        value={this.state.idcard}
                        onChange={(e)=>{this.onChange(e,'idcard')}}
                        style={{width:'200px'}}
                    />
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>银行卡开户行 :</div>
                    <CInput
                        value={this.state.bankname}
                        onChange={(e)=>{this.onChange(e,'bankname')}}
                        style={{width:'200px'}}
                    />
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>工作单位:</div>
                    <CInput
                        value={this.state.workunit}
                        onChange={(e)=>{this.onChange(e,'workunit')}}
                        style={{width:'200px'}}
                    />
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>职务:</div>
                    <CInput
                        value={this.state.position}
                        onChange={(e)=>{this.onChange(e,'position')}}
                        style={{width:'200px'}}
                    />
                </div>
                <div style={{marginBottom:'20px',display:'flex'}}>
                    <div style={{marginRight:'20px',width:'100px',textAlign:"right"}}>职称:</div>
                    <CInput
                        value={this.state.jobtitle}
                        onChange={(e)=>{this.onChange(e,'jobtitle')}}
                        style={{width:'200px'}}
                    />
                </div>


                <div style={{paddingLeft:'200px'}} >
                    <CButton type='primary' onClick={() => this.save()} style={{marginLeft:'20px'}}>保存</CButton>
                </div>
                <Modal
                    title={this.state.modal.title}
                    visible={this.state.modal.visible}
                    onOk={this.modalOk}
                    onCancel={this.modalCancel}
                    closable={false}
                >
                    <div>
                        <Form
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 16 }}
                            style={{ maxWidth: 600 }}
                        >
                            <Form.Item
                                label="请输入新密码"
                                rules={[{ required: true, message: '请输入新密码' }]}
                            >
                                <Input value={this.state.psd1}
                                       onChange={(e) => this.enterHandler(e,'psd1')}
                                       onPressEnter={(e) => this.enterHandler(e,'psd1')}/>
                            </Form.Item>
                            <Form.Item
                                label="再次输入新密码"
                                rules={[{ required: true, message: '再次输入新密码' }]}
                            >
                                <Input value={this.state.psd2}
                                       onChange={(e) => this.enterHandler(e,'psd2')}
                                       onPressEnter={(e) => this.enterHandler(e,'psd2')}/>
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.modal1.visible}
                    onOk={this.modalOk1}
                    onCancel={this.modalCancel1}
                    closable={false}
                >
                    <div>
                        <CInput value={this.state.mobiles} placeholder='请输入手机号'  onChange={(value)=>this.changHandler(value)}/>
                        <div className='phone-block'>
                            <CInput value={this.state.vcode} placeholder='请输入验证码' onChange={(value) => this.changHandler1(value)} />
                            <Time seconds={60} mobile={this.state.mobiles} />
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        reload: state.reload,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setReload: bindActionCreators(setReload, dispatch)
    }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
